module.exports = __webpack_public_path__ + "static/media/3D.8ff80643.svg";